import { BaseApiService } from './baseApi';
//  correction - Import depuis le système unifié
import type { AboutInfo, ApiResponse } from '../../../../types';

export class AboutApiService extends BaseApiService {
  constructor() {
    super('/about');
  }

  /**
   * Fetch les informations About
   */
  async getAbout(): Promise<ApiResponse<AboutInfo>> {
    return this.requestGet<AboutInfo>('', false);
  }

  /**
   * Update les informations About
   */
  async updateAbout(data: Partial<AboutInfo>): Promise<ApiResponse<AboutInfo>> {
    return this.requestPut<AboutInfo>('', data);
  }

  /**
   * Create les informations About
   */
  async createAbout(data: Partial<AboutInfo>): Promise<ApiResponse<AboutInfo>> {
    return this.requestPost<AboutInfo>('', data);
  }

  /**
   * Delete les informations About
   */
  async deleteAbout(): Promise<ApiResponse<boolean>> {
    return this.requestDelete<boolean>('');
  }

  /**
   * Toggle la visibilité
   */
  async toggleVisibility(): Promise<ApiResponse<AboutInfo>> {
    return this.requestPatch<AboutInfo>('/visibility');
  }

  /**
   * Get les liens sociaux
   */
  async getSocialLinks(): Promise<ApiResponse<Record<string, string>>> {
    return this.requestGet<Record<string, string>>('/social-links', false);
  }

  /**
   * Get le score de complétion
   */
  async getCompletionScore(): Promise<ApiResponse<{ completionScore: number }>> {
    return this.requestGet<{ completionScore: number }>('/admin/completion');
  }

  /**
   * Valider l'intégrité des données
   */
  async validateIntegrity(): Promise<ApiResponse<{
    isConfigured: boolean;
    completionScore: number;
    hasFrenchProfile: boolean;
    hasEnglishProfile: boolean;
    socialLinksCount: number;
    issues: string[];
    recommendations: string[];
  }>> {
    return this.requestGet('/admin/validate');
  }

  /**
   * Initialiser les données par défaut
   */
  async initializeDefault(): Promise<ApiResponse<AboutInfo>> {
    return this.requestPost<AboutInfo>('/admin/initialize', {});
  }
}

export const aboutApi = new AboutApiService();
